import useTranslation from 'next-translate/useTranslation';
import { Container, Content, ModalHeader } from './style';
import TermsContent from './Content';
import { Modal } from '@starsoft/common/components';
import { useModal } from '@/hooks/modals/useModal';
import { ModalsKey } from '@/enums/modalsKey';

export default function TermsModal() {
  const { t } = useTranslation('common');
  const { handleContainer, isOpen, onClose } = useModal(ModalsKey.Terms);

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Container onClick={handleContainer}>
        <ModalHeader>
          <h3>{t('terms_title')}</h3>
          <i className="fas fa-times" onClick={() => onClose()} />
        </ModalHeader>
        <Content>
          <TermsContent />
        </Content>
      </Container>
    </Modal>
  );
}
